module.exports = __webpack_public_path__ + "ta_ico.png?f88e9baad356c56503f4630df4c32338";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/ta_ico.png
// module id = 462
// module chunks = 0